// Lineups from the server (frozen days), loop data in batches of ≤ 64.
import type { Bpm, Lineup, LoopData, PeriodDef } from "@eb/shared";
import { api } from "../api";
import type { LineupSource } from "./source";

export class ServerSource implements LineupSource {
  readonly name = "server";
  constructor(private readonly epoch: number) {}

  epochMs(): number {
    return this.epoch;
  }

  period(day: number, bpm?: Bpm): Promise<PeriodDef> {
    return api<PeriodDef>("GET", `/api/periods/${day}${bpm ? `?bpm=${bpm}` : ""}`);
  }

  lineup(day: number): Promise<Lineup> {
    return api<Lineup>("GET", `/api/lineups/${day}`);
  }

  async loops(ids: string[]): Promise<Map<string, LoopData>> {
    const out = new Map<string, LoopData>();
    for (let i = 0; i < ids.length; i += 64) {
      const batch = ids.slice(i, i + 64);
      const r = await api<{ loops: { id: string; data: LoopData }[] }>(
        "GET",
        `/api/loops?ids=${batch.map(encodeURIComponent).join(",")}`,
      );
      for (const l of r.loops) out.set(l.id, l.data);
    }
    return out;
  }
}
